import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"

import { toast } from "react-toastify"

function IncidentInfo({ setValidIncident, setIsEvaluated }) {
  const { o } = useParams()
  const hashId = o

  const [customerName, setCustomerName] = useState("")
  const [title, setTitle] = useState("")
  const [responsibleAnayst, setResponsibleAnalyst] = useState("")

  useEffect(() => {
    async function fetchData() {
      try {
        const url = process.env.REACT_APP_API_URL + "survey/" + hashId
        const response = await axios.get(url)

        const { customerName, title, responsibleAnalyst } = response.data
        const { grade } = response.data[0]

        setCustomerName(customerName)
        setTitle(title)
        setResponsibleAnalyst(responsibleAnalyst)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }
    fetchData()
  }, [hashId])

  return (
    <>
      <p>Prezado(a) {customerName}</p>
      <div className="msg-form">
        <p>Agradecemos por compartilhar sua opinião conosco!</p>
        <p>
          É muito importante saber o que você tem a nos dizer, para que possamos
          aprimorar a qualidade dos nossos serviços.
        </p>
        <p>
          Caso você tenha alguma dúvida ou sugestão adicional, entre em contato
          conosco pelo e-mail{" "}
          <a className="a-survey" href="mailto:gerenciaservicos@ngxit.com.br">
            gerenciaservicos@ngxit.com.br
          </a>
          .
        </p>
      </div>
      <div className="desc-wrapper">
        <div className="desc-wrapper-each">
          <p>Título da ocorrência:</p>
          <div>{title}</div>
        </div>
        <div className="desc-wrapper-each">
          <p>Analista responsável:</p>
          <div>{responsibleAnayst}</div>
        </div>
      </div>
    </>
  )
}

export default IncidentInfo
